import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchReportGroups, fetchReportsByGroup } from '../services/reportService';

// Fetch grupos de reportes
export const fetchReportGroupsData = createAsyncThunk(
    'reports/fetchReportGroupsData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchReportGroups();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// Fetch reportes de un grupo específico
export const fetchReportsData = createAsyncThunk(
    'reports/fetchReportsData',
    async (groupId, { rejectWithValue }) => {
        try {
            const data = await fetchReportsByGroup(groupId);
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const reportSlice = createSlice({
    name: 'reports',
    initialState: {
        reportGroups: [],
        reports: [],
        selectedGroupId: null,
        loading: false,
        error: null,
    },
    reducers: {
        setSelectedGroup(state, action) {
            state.selectedGroupId = action.payload;
        },
        clearReports(state) {
            state.reports = [];
        },
    },
    extraReducers: (builder) => {
        builder
            // Report Groups
            .addCase(fetchReportGroupsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchReportGroupsData.fulfilled, (state, action) => {
                state.loading = false;
                state.reportGroups = action.payload;
            })
            .addCase(fetchReportGroupsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Reports by Group
            .addCase(fetchReportsData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchReportsData.fulfilled, (state, action) => {
                state.loading = false;
                state.reports = action.payload;
            })
            .addCase(fetchReportsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setSelectedGroup, clearReports } = reportSlice.actions;
export default reportSlice.reducer;
